import React from "react";
import { motion } from "framer-motion";
import { FAQ } from "@/lib/content";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function Faq() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 md:py-36"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-6">
          <span className="w-8 h-px bg-[#1F5EFF]" />
          <span className="font-mono-alt text-[12px] text-[#1F5EFF]">FAQ</span>
        </div>
        <h2 className="font-display text-4xl md:text-6xl font-light tracking-tight text-white leading-[1.02] mb-14">
          Questions,{" "}
          <span className="text-white/50">answered.</span>
        </h2>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Accordion type="single" collapsible className="w-full">
            {FAQ.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-white/10 py-2"
              >
                <AccordionTrigger
                  className="text-left text-white text-lg md:text-xl font-display hover:no-underline hover:text-[#1F5EFF] py-6"
                  data-testid={`faq-trigger-${i}`}
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-white/60 text-base leading-relaxed pb-6 pr-8">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
